'use client';

import { useTelegramBackButtonSetup } from '@/hooks/useTelegramBackButton';

/**
 * Mounts Telegram's hardware back button once per session and wires
 * its click to the URL navigation adapter (which calls
 * router.back()). Visibility flips on/off based on
 * `navigation.canGoBack()` — under URL nav that maps to "current
 * pathname is not the active tab's root".
 *
 * Lives inside (auth)/layout.tsx so it co-mounts with the authed
 * provider tree. (public) routes don't need this; the desktop
 * marketing page has its own header back navigation.
 */
export function TelegramBackButtonSetup() {
  useTelegramBackButtonSetup();
  return null;
}
